import { RootState } from '../Store';

export const selectActiveGOrgId = (state: RootState): string | null =>
  state.globalCatalogueReducer.activeGOrganisation || null;
